import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import {
  canAccessRecapturaCarga,
  canAccessRecapturaOperativo,
  canAccessRecapturaResumen,
  canDecideRecaptura,
} from '../utils/gestionCampanaAccess'

const GATES = {
  operativo: canAccessRecapturaOperativo,
  resumen: canAccessRecapturaResumen,
  aprobaciones: canDecideRecaptura,
  carga: canAccessRecapturaCarga,
}

/**
 * @param {'operativo'|'resumen'|'aprobaciones'|'carga'} mode
 */
const RequireRecapturaAccess = ({ children, mode = 'operativo' }) => {
  const { user } = useUser()
  const gate = GATES[mode] || canAccessRecapturaOperativo
  if (!gate(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireRecapturaAccess
